import type { EnclosingNote } from 'features/insights/components/enclosing-notification-bar/types';
import { enclosingNotesSignal } from 'features/insights/store/signals/insights.signals';

export const getEnclosingNote = () => {
    if (enclosingNotesSignal.value) {
        const parentNames = enclosingNotesSignal.value
            .filter((item) => item.enclosedPropertyName !== item.enclosedParentName)
            .map((item) => item.enclosedParentName);
        const propertiesNames = enclosingNotesSignal.value.map((item) => item.enclosedPropertyName);
        const uniqPropertiesNames = [...new Set(propertiesNames)];
        const uniqParentNames = [...new Set(parentNames)];

        if (!parentNames.length || !propertiesNames.length) return;

        return `${uniqPropertiesNames.join(', ')} ${
            uniqPropertiesNames.length === 1 ? 'is' : 'are'
        } located within a larger enclosed structure. Therefore, visitation data is unavailable. This report presents data for ${uniqParentNames.join(
            ', ',
        )}, the enclosing ${uniqParentNames.length === 1 ? 'property' : 'properties'}.`;
    }
};

export const setEnclosingNote = (note: EnclosingNote) => {
    const enclosedParentComplexes =
        localStorage.getItem('enclosedParentComplexes') ||
        JSON.stringify(enclosingNotesSignal.value);

    const enclosingNotesToSet: EnclosingNote[] = [
        ...(enclosedParentComplexes ? JSON.parse(enclosedParentComplexes) : []),
        note,
    ];

    localStorage.setItem('enclosedParentComplexes', JSON.stringify(enclosingNotesToSet));
    enclosingNotesSignal.value = enclosingNotesToSet;
};

export const deleteEnclosingNote = (note: EnclosingNote) => {
    if (enclosingNotesSignal.value) {
        const enclosingNotesToSet = enclosingNotesSignal.value.filter(
            ({ enclosedParentName, enclosedPropertyName }) =>
                !(
                    enclosedParentName === note.enclosedParentName &&
                    enclosedPropertyName === note.enclosedPropertyName
                ),
        );

        localStorage.setItem('enclosedParentComplexes', JSON.stringify(enclosingNotesToSet));
        enclosingNotesSignal.value = enclosingNotesToSet;
    }
};

export const clearEnclosingNotes = () => {
    localStorage.removeItem('enclosedParentComplexes');
    enclosingNotesSignal.value = undefined;
};

export const clearTempEnclosingNotes = () => {
    enclosingNotesSignal.value = undefined;
};
